import React from 'react';
import { injectIntl, intlShape } from 'react-intl';

import messages from './messages';

import styles from './styles';

const IconCustom = ({ iconUrl, intl }) => {
  styles.custom.backgroundImage = `url("${iconUrl}")`;
  return (
    <div
      style={styles.custom}
      role="img"
      aria-label={intl.formatMessage(messages.aria_label_custom_icon, { iconUrl })}
    />
  );
};

IconCustom.propTypes = {
  iconUrl: React.PropTypes.string,
  intl: intlShape.isRequired,
};

IconCustom.defaultProps = {
  iconUrl: '',
};

export default injectIntl(IconCustom);
